import React, { useState } from 'react';
import { TContentHubSeriesDetailsProps } from '../types/productSeriesDetailFeature.types';
import ComponentDetails from './componentDetails';
import { SeriesDetailsModel } from '../models/productSeriesDetailFeature.model';
import { Element } from 'react-scroll';
import Icon from '../../@shared/icon';
import { googleClickTabEvent } from '../../../utils/analytics';
import FeatureHeader from './featureHeader';
import { titleKeySeriesFeature } from '../../../constants/dictionary.constants';
import useShowProductComponentTitle from '../../../hooks/useShowProductComponentTitle';

const MobileSeriesDetails = (props: TContentHubSeriesDetailsProps): JSX.Element => {
  const model = new SeriesDetailsModel(props);
  const hasTitile = !!model?.title;
  const showTitle = useShowProductComponentTitle(hasTitile, [titleKeySeriesFeature]);

  const [collapsedTabs, setCollapsedTabs] = useState(model.innerComponents?.map(({ id }) => id));

  const toggleTab = (tabId: number): void => {
    if (collapsedTabs.includes(tabId)) {
      setCollapsedTabs(collapsedTabs.filter((tab) => tab !== tabId));
    } else {
      setCollapsedTabs([...collapsedTabs, tabId]);
    }
  };

  return (
    <Element name="Features">
      <section className="series-details">
        <div className="series-details__container">
        {showTitle && <FeatureHeader title={model?.title} titleKeySeriesFeature={titleKeySeriesFeature} />}

          <ul className="series-details__tabs">
            {model?.innerComponents?.map((component, index) => {
              const isCollapsed = collapsedTabs.includes(component.id);
              return (
                <li className="series-details__tab" key={component.id}>
                  <button
                    className={'series-details__tab-button' + (!isCollapsed ? ' series-details__tab-button--opened' : '')}
                    onClick={() => {
                      toggleTab(component.id);
                      googleClickTabEvent('Open', component?.eyebrow, index + 1);
                    }}
                  >
                    <span>{component?.eyebrow}</span>
                    <Icon size={24} iconName={isCollapsed ? 'arrow-chevron-down' : 'arrow-chevron-up'} />
                  </button>
                  <ComponentDetails
                    backgroundColor={model.backgroundColor}
                    component={model.innerComponents[index]}
                    className={`series-details__component ${!isCollapsed ? 'series-details__component--show' : ''}`}
                  />
                </li>
              );
            })}
          </ul>
        </div>
      </section>
    </Element>
  );
};

export default MobileSeriesDetails;
